import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import 'rxjs/add/operator/map';
// import { AngularFireAuth } from 'angularfire2/auth';

import { Observable } from 'rxjs/Rx';

@Injectable()
export class AuthGuard implements CanActivate{

  constructor (
    private router:Router,
   // public afAuth:AngularFireAuth,
    public authService: AuthService
    ){}

   canActivate(): Observable<boolean>{
   // if(this.authService.authenticated)
      return this.authService.afAuth.authState.map(auth => {
       if(!auth){
           this.router.navigate(['session/signin']);
           return false;
       } else {
          this.authService.getUserDetails().subscribe(resp => {
          console.log('etape 2', resp)
          if ( resp.isSecretSet === false ) {
            this.router.navigate(['session/account']);
          }
         });

         return true;
       }
     });
   }
}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/guards/auth.guard.ts